import { applyReceiptOptions, DEFAULT_TEMPLATES, fillTemplate, render, resolveParams, type ReceiptOptions } from '@iws/pos-devices'

import { useMemo } from 'react'

interface Props {
    shop: { name?: string; address?: string; contact_number?: string; email?: string; registration_number?: string; sst_id?: string }
    options?: ReceiptOptions
    footer: string
    returnDays: number
}

const SAMPLE_ORDER = {
    number: '2026-1102-T1-0007',
    date: '02 Nov 2026, 10:15',
    counter: 'Terminal 1',
    cashier: 'Cashier',
    lines: [
        { name: 'Miniket Rice 5 kg', qty: '2', price: '450.00', total: '900.00', note: '' },
        { name: 'Mineral Water 500 ml', qty: '3', price: '20.00', total: '60.00', note: ' (disc)' },
    ],
    subtotal: '960.00',
    discount: '10.00',
    tax: '',
    adjustment: '',
    total: 'BDT 950.00',
    payments: [{ method: 'Cash', amount: '1000.00' }],
    change: '50.00',
    items: 5,
}

/** A sample sale printed with the tills' own receipt template, the business's details and the footer as typed. */
export const ReceiptPreview = ({ shop, options, footer, returnDays }: Props) => {
    const html = useMemo(() => {
        const data = {
            shop: {
                name: shop.name ?? '',
                address: shop.address,
                phone: shop.contact_number,
                email: shop.email,
                registration_no: shop.registration_number,
                tax_id: shop.sst_id,
                return_days: returnDays,
            },
            options: { footer: footer.trim() || 'Thank you for shopping!' },
            order: { ...SAMPLE_ORDER, customer: { name: 'Walk-in customer', phone: '01700000000' } },
        }
        const doc = fillTemplate(DEFAULT_TEMPLATES.receipt, applyReceiptOptions(data, options))
        const out = render('html', doc, resolveParams('html'), { title: 'Receipt preview' })
        return 'text' in out ? out.text : ''
    }, [shop.name, shop.address, shop.contact_number, shop.email, shop.registration_number, shop.sst_id, options, footer, returnDays])

    return (
        <iframe
            title="Receipt preview"
            srcDoc={html}
            sandbox=""
            className="h-[28rem] w-full max-w-sm rounded-md border border-border bg-card"
        />
    )
}
